module.exports = __webpack_public_path__ + "static/media/chard.c3c4d17c.jpg";